// ============================================================================
// SOUND LIBRARY SERVICE (Frontend)
// The shared sound effect library used by films (Admin > Sound Effects).
// ============================================================================

import { api } from './api';

export interface SoundLibraryEffect {
  name: string;
  label: string;
  tags: string[];
  prompt: string;
  durationSec: number;
  promptInfluence?: number;
  loop?: boolean;
  sha?: string;
  enabled: boolean;
  source: 'seed' | 'mcp';
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export type SoundLibraryPatch = Partial<Pick<SoundLibraryEffect, 'label' | 'tags' | 'enabled'>>;

export const soundLibraryService = {
  async list(): Promise<SoundLibraryEffect[]> {
    const { data } = await api.get<{ effects: SoundLibraryEffect[] }>('/api/sound-library');
    return data.effects;
  },

  async audioUrl(name: string): Promise<string> {
    const { data } = await api.get<{ url: string }>(`/api/sound-library/${encodeURIComponent(name)}/audio`);
    return data.url;
  },

  async update(name: string, patch: SoundLibraryPatch): Promise<SoundLibraryEffect> {
    const { data } = await api.put<{ effect: SoundLibraryEffect }>(`/api/sound-library/${encodeURIComponent(name)}`, patch);
    return data.effect;
  },
};
